import { useEffect, useRef } from 'react';

import reportOther, { EReportOtherKey } from '@/utils/report/reportOther';
import { Request } from '@/utils/request';

const useActivity = () => {
  const ref = useRef<NodeJS.Timeout | null>(null);

  const reportActivity = () => {
    Request({
      url: '/rest/os/event/report/activity/report',
      method: 'post'
    });
    reportOther(EReportOtherKey.activity, {
      key1: !!document.querySelector('#mebot-save-content')
    });
  };

  useEffect(() => {
    reportActivity();

    ref.current = setInterval(
      () => {
        reportActivity();
      },
      60 * 60 * 1000
    );

    const handleReport = () => {
      if (!document.hidden) {
        reportActivity();
      }
    };

    window.addEventListener('beforeunload', handleReport);
    window.addEventListener('visibilitychange', handleReport);

    return () => {
      window.removeEventListener('beforeunload', handleReport);
      window.removeEventListener('visibilitychange', handleReport);

      if (ref.current) {
        clearInterval(ref.current);
        ref.current = null;
      }
    };
  }, []);
};

export default useActivity;
